import { ErrorType, SubmitError } from '../types';
export const createSaveFormError = e => new SubmitError(ErrorType.Save, e);
export const createSubmitFormError = e => new SubmitError(ErrorType.Submit, e);
export const createValidateFormError = () => new SubmitError(ErrorType.Validation, new Error('Validation failure'));